var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M13 2L4.5 13.5h6L9 22l9-12h-6L13 2z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }